type QueryKeysType = {
  [key: string]: string;
};

export const GET_BANNER_ADS_QUERY_KEY: QueryKeysType = {
  PHARMACIST_WEB_SIDE_SMALL: 'PHARMACY_WEB_SIDE_SMALL',
  PHARMACIST_WEB_SIDE_BIG: 'PHARMACY_WEB_SIDE_BIG'
} as const;

export const SEND_AD_BANNER_EXPOSURE_LOG =
  'SEND_AD_BANNER_EXPOSURE_LOG' as const;
